import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mx-auto mt-4 mb-4" }
const _hoisted_2 = { class: "col-12 font-weight-bold px-0 mb-3" }
const _hoisted_3 = { class: "col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0" }
const _hoisted_4 = { class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_button_delete = _resolveComponent("button-delete")!
  const _component_button_save = _resolveComponent("button-save")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$tc(_ctx.i18nMessage, _ctx.i18nParams)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_button_cancel, {
        onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('canceled'))),
        class: "btn-w-100"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.confirmButtonType === 'delete')
        ? (_openBlock(), _createBlock(_component_button_delete, {
            key: 0,
            i18nMessage: _ctx.i18nDeleteMessage,
            onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirmed'))),
            class: "btn-w-100"
          }, null, 8, ["i18nMessage"]))
        : _createCommentVNode("", true),
      (_ctx.confirmButtonType === 'save')
        ? (_openBlock(), _createBlock(_component_button_save, {
            key: 1,
            onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirmed'))),
            class: "btn-w-100"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}